<template>
    <Transition name="fade" appear>
        <button
            v-if="isReady"
            type="button"
            class="font-medium inline-flex items-center gap-2 rounded-full border-[2px] border-grind-800 bg-light-gray px-5 py-2 text-grind-800"
            @click="openZendeskChat(source)"
        >
            <Icon name="comment-regular" class="text-[1.3rem]" />
            {{ label }}
        </button>
    </Transition>
</template>

<script setup lang="ts">
import { openZendeskChat } from '~/utils/zendeskChat';

withDefaults(
    defineProps<{
        source?: string;
        label?: string;
    }>(),
    {
        source: 'Chat Button',
        label: 'Chat',
    },
);

const isReady = ref(false);

const markReady = () => {
    isReady.value = true;
};

onMounted(() => {
    if (window._zopimReady) {
        markReady();
        return;
    }
    window.addEventListener('zopim:ready', markReady, { once: true });
});

onBeforeUnmount(() => {
    window.removeEventListener('zopim:ready', markReady);
});
</script>
